import * as React from 'react'
import { cn } from '@/shared/lib/utils'

export interface InputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'ref'> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          `flex w-full rounded-3xl border bg-white px-4 py-4 text-sm text-[var(--foreground)] transition duration-200`,
          `border-[var(--color-input-border)]`,
          `hover:border-[var(--foreground)]`,
          `placeholder:text-[var(--color-muted-text)]`,
          `focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--foreground)] focus-visible:ring-offset-0`,
          `disabled:cursor-not-allowed disabled:opacity-50`,
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
